import { useState } from "react";
import { fetchOffers } from "../api/offersApi";

export function useOffers() {
    const [offers, setOffers] = useState([]);

    const load = async () => {
        setOffers(await fetchOffers());
    };

    // поменял и сохранил

    return { offers, setOffers, load };
}
